module.exports = __webpack_public_path__ + "assets/img/leo_w_app.377dfa98.png";